import request from '../utils/request';

//展商登录
export function login(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/onlineExhibition/frontExhibitor/login',
    method: 'post',
    data: formData,
  });
}

//展商注销
export function logout(data) {
  return request({
    url: '/onlineExhibition/signOut',
    method: 'get',
    params: data,
  });
}

//Vr同步登录(废弃)
export function loginVr(data) {
  return request({
    url: '/apiaccount/signin',
    method: 'get',
    params: data,
  });
}
//Vr同步退出登录(废弃)
export function exitVr(data) {
  return request({
    url: '/apiaccount/logout',
    method: 'get',
    params: data,
  });
}
